module.exports = {"title":"Week 9: Almost there","body":"<p>We continue working on training the data, classification, implementing the GUI, and writing up the documentation.  We met with Ana again to give an update on our current progress.  The quarter is coming to an end soon, so we will give the class a final oral update presentation on what we have been working on the whole quarter, featuring demo videos.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./process/week-9/index.md
// module id = 500
// module chunks = 0